import { apiPost, apiGet } from "./request";

export interface CouponPayload {
  id?: number;
  code?: string;
  type: "FIXED" | "PERCENT" | "ZERO_FEE";
  appliedOn?: "B2B" | "B2C" | "ALL" | "HIDDEN" | "APP";
  channel?: "IOS" | "ANDROID" | "APP" | "WEB" | "ALL";
  amount: number;
  maxDiscount?: number | null;
  minOrderTotal?: number | null;
  startsAt: string;
  endsAt: string;
  totalLimit?: number | null;
  perUserLimit?: number | null;
}

export interface UpdateStatusPayload {
  id: number;
  status: "ACTIVE" | "INACTIVE";
}

export const couponApi = {
  // GET ALL COUPONS
  getAll: async () => {
    const response = await apiGet("/coupon/getAllCoupons");
    return response?.result ?? [];
  },

  // CREATE COUPON
  create: async (payload: CouponPayload) => {
    const response = await apiPost("/coupon/createCoupon", payload);
    return response?.result;
  },

  // UPDATE COUPON
  update: async (payload: CouponPayload) => {
    const response = await apiPost("/coupon/updateCoupon", payload);
    console.log(response);
    return response?.result;
  },

  // UPDATE COUPON STATUS
  updateStatus: async (payload: UpdateStatusPayload) => {
    const response = await apiPost("/coupon/updateCouponStatus", payload);
    return response?.result;
  },
};
